module.exports = __webpack_public_path__ + "static/media/checkbox.757db9fd.svg";